module.exports = __webpack_public_path__ + "static/media/gn.static.d178c54b.svg";